import React from 'react';

import { DialogTitle as MuiDialogTitle } from '@material-ui/core';
import { IconButton, Typography, useTheme } from '@material-ui/core';
import { MdClose } from 'react-icons/md';

const DialogTitle = ({ onClose, children, ...props }) => {
  const theme = useTheme();

  if (typeof onClose === 'function') {
    return (
      <MuiDialogTitle disableTypography {...props} style={{ paddingRight: 50 }}>
        <Typography variant="h6">{children}</Typography>

        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
          }}
        >
          <MdClose />
        </IconButton>
      </MuiDialogTitle>
    );
  }

  return <MuiDialogTitle>{children}</MuiDialogTitle>;
};

export default DialogTitle;
